<template>
  <div class="conversation component">
    <template v-for="(message, i) in conversation">
      <!-- Prompt -->
      <SpeechBubble
        v-if="message.type === 'prompt'"
        @display="next"
        @scroll="$emit('scroll')"
        :message="interpolate(copy[message.text])"
        :avatar="logo"
        :key="`message-${i}`"
        color="white"
      >
        <!-- Component -->
        <div v-if="message.component && typeof message.component === 'object'">
          <div
            :is="message.component.name"
            @done="componentDone"
            @input="e => (message.component.onInput ? message.component.onInput(e) : '')"
            @scroll="$emit('scroll')"
            v-bind="message.component.props ? message.component.props : {}"
          />
        </div>

        <!-- Buttons -->
        <div v-if="message.buttons && message.buttons.length > 0">
          <v-btn
            v-for="(button, j) in message.buttons"
            :key="`button-${j}`"
            :color="themes.candidate.light.primaryActionButton"
            @click="
              button.onClick ? button.onClick() : ''
              next(button.next)
            "
            v-bind="button.props ? button.props : {}"
          >
            {{ button.text }}
          </v-btn>
        </div>

        <!-- Help tooltip -->
        <div slot="help" v-if="message.help && (message.help.text || message.help.html)">
          <div v-html="message.help.html" />
          <div v-text="message.help.text" />
        </div>
      </SpeechBubble>

      <!-- Response -->
      <SpeechBubble
        alt
        dark
        v-if="message.type === 'response'"
        @display="next"
        :key="`message-reponse-${i}`"
        :message="interpolate(copy[message.text])"
        :color="themes.candidate.light.primary"
        :delay="0"
        :show-typing="false"
      />
    </template>
  </div>
</template>

<script>
// Components
import CampaignEligibilitiesList from '@/components/prompts/CampaignEligibilitiesList'
import EmailConfirmation from '@/components/candidate/profile/account/EmailConfirmation'
import IdentityForm from '@/components/candidate/signup/IdentityForm'
import Login from '@/components/Login'
import NameForm from '@/components/candidate/signup/NameForm'
import Register from '@/components/Register'
import SpeechBubble from '@/components/prompts/SpeechBubble'

// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Data
import signupCopy from '@/data/signup_copy'

export default {
  components: {
    CampaignEligibilitiesList,
    EmailConfirmation,
    IdentityForm,
    Login,
    NameForm,
    Register,
    SpeechBubble,
  },

  mounted() {
    if (this.value && this.value[0]) this.conversation.push(this.value[0])

    if (this.campaign) this.copy = Object.assign(signupCopy.standard, signupCopy.campaigns)

    if (this.campaign && signupCopy[this.campaignOrganization.id]) {
      this.copy = Object.assign(this.copy, signupCopy[this.campaignOrganization.id])
    }
  },

  props: { value: Array, interpolations: Object },

  data() {
    return {
      conversation: [],
      copy: JSON.parse(JSON.stringify(signupCopy.standard)),
    }
  },

  computed: {
    ...mapGetters({
      campaign: 'campaign/model',
      profile: 'candidate/profile/model',
      providers: 'auth/providers',
      user: 'auth/user',
      campaignOrganization: 'campaign/organization',
      logoUrl: 'campaign/logo',
    }),

    current() {
      if (this.conversation.length) return this.conversation[this.conversation.length - 1]
      return null
    },

    logo() {
      // if (this.logoUrl) return this.$store.state.images.images[this.logoUrl]
			if (this.logoUrl) return this.logoUrl
      return '/img/leaply-rainbow-square.png'
    },
  },

  methods: {
    next(key) {
      // Call done if last message
      if (_.get(this.current, 'last')) {
        this.done()
        return
      }

      // Get and Push new message
      const next = this.value.find(message => {
        // Use provided next key
        if (!isNaN(key) && key >= 0) return message.key === key
        // Use current message's next
        if (_.get(this.current, 'next') >= 0) return message.key === this.current.next
        // Use current message's next()
        if (_.get(this.current, 'next') && this.current.next() >= 0) {
          return message.key === this.current.next()
        }
      })

      if (next) this.conversation.push(next)

      // Scroll
      this.$emit('scroll')
    },

    interpolate(text) {
      if (!/%{[^}\r\n]*}/.test(text) || typeof text !== 'string') return text

      let interpolated = text
      if (this.user) {
        interpolated = interpolated.replace('%{candidate_email}', this.user.email)
      }
      if (this.campaign) {
        interpolated = interpolated.replace('%{organization_name}', this.campaignOrganization.name)
      }
      if (this.providers) {
        interpolated = interpolated.replace(
          '%{auth_providers}',
          this.providers.length
            ? this.providers.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(', ')
            : 'my email'
        )
      }
      if (this.profile) {
        interpolated = interpolated.replace('%{candidate_first_names}', this.profile.firstNames)
        interpolated = interpolated.replace(
          '%{candidate_identification}',
          this.profile.identification
        )
        interpolated = interpolated.replace('%{candidate_last_name}', this.profile.lastName)
        interpolated = interpolated.replace(
          '%{candidate_date_of_birth}',
          this.$date(new Date(this.profile.bornAt), "do 'of' MMM yyy")
        )
      }
      if (this.profile && this.profile.MobileNumberForm) {
        interpolated = interpolated.replace(
          '%{candidate_mobile_number}',
          this.profile.mobileNumber.substring(3)
        )
      }
      if (this.interpolations) {
        Object.keys(this.interpolations).forEach(i => {
          interpolated = interpolated.replace(`%{${i}}`, this.interpolations[i])
        })
      }
      return interpolated
    },

    componentDone(e) {
      if (!_.get(this.current, 'component.next')) return
      if (e) {
        this.next(this.current.component.next[e])
        return
      }

      this.next(this.current.component.next)
      return
    },

    done() {
      this.$emit('done')
    },
  },
}
</script>
